// generated from 813_242 samples

import { z } from "zod";
import { common } from "../common";
import { clickActionSchema } from "../shared/clickActionSchema";
import { interruptionLevelSchema } from "../shared/interruptionLevelSchema";
import { justificationAlignmentSchema } from "../shared/justificationAlignmentSchema";
import { messageGetBaseSchema } from "./messageGetBaseSchema";

export const iosPushMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("iosPush"),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // true 1 (0.00%), false 780_438 (100.00%)
  ios_abort_on_asset_failure: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 21_308 (2.73%)
  ios_alert_hash: z
    .object({
      "action-loc-key": z.union([z.string(), z.array(z.string())]).optional(),
      "launch-image": z.union([z.string(), z.array(z.string())]).optional(),
      "loc-args": z.array(z.string()).optional(),
      "loc-key": z.array(z.string()).optional(),
      "summary-arg": z.union([z.string(), z.array(z.string()).length(1)]).optional(),
      "summary-arg-count": z.union([z.string(), z.array(z.string()).length(1)]).optional(),
      title: z.string(),
      "title-loc-args": z.tuple([z.string()]).optional(),
      "title-loc-key": z.union([z.string(), z.array(z.string()).length(1)]).optional(),
    })
    .nullable()
    .optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 662_041 (84.83%)
  ios_asset_file_type: z.string().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 757_991 (97.12%)
  // format integer: 22_077 (98.35%)
  ios_badge: z.string().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  ios_carousel_slides: z
    .array(
      z.object({
        // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
        action_type: clickActionSchema.nullable(),
        // null: 131 (2.31%)
        hosted_image_url: z.string().nullable(),
        human_readable: z.string(),
        id: common.objectId,
        // null: 4 (0.07%)
        image_type: z.string().nullable(),
        // true 661 (11.66%), false 5_006 (88.34%)
        is_custom_image_url: z.boolean(),
        // null: 2_634 (46.48%)
        link: z.string().nullable(),
        // null: 3_314 (58.48%)
        marked_as_deleted: z.boolean().nullable(),
        // null: 1_615 (28.50%)
        subtitle: z.string().nullable(),
        // null: 42 (0.74%)
        subtitle_justification: justificationAlignmentSchema.nullable(),
        // null: 1_655 (29.20%)
        title: z.string().nullable(),
        // null: 42 (0.74%)
        title_justification: justificationAlignmentSchema.nullable(),
        // null: 5_133 (90.58%)
        // true 453 (84.83%), false 81 (15.17%)
        use_webview: z.boolean().nullable().optional(),
      })
    )
    .optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 779_305 (99.85%)
  ios_carousel_type: z.literal(7).nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 779_330 (99.86%)
  ios_collapse_id: z.string().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // true 5_579 (0.71%), false 774_860 (99.29%)
  ios_content_available: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  ios_exclude_provisional_opt_in: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 713_894 (91.47%)
  ios_extras: z.record(z.string(), z.string()).nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 662_040 (84.83%)
  ios_image_url: z.string().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 7_929 (1.02%)
  // Canonical values from shared_constants.json IOS_INTERRUPTION_LEVEL
  ios_interruption_level: interruptionLevelSchema.nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // true 20_082 (2.57%), false 760_357 (97.43%)
  ios_is_custom_image_url: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // true 3_876 (0.50%), false 776_563 (99.50%)
  ios_mutable_content: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 776_577 (99.51%)
  ios_notification_group_object_id: common.objectId.nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // true 592 (0.08%), false 779_847 (99.92%)
  ios_only_ipads: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // true 9_546 (1.22%), false 770_893 (98.78%)
  ios_only_iphones: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // true 185_344 (23.75%), false 595_095 (76.25%)
  ios_only_most_recent_device: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  ios_only_send_to_provisional_opt_in: z.boolean().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  ios_push_buttons: z
    .array(
      z.object({
        // null: 315 (3.65%)
        // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
        action_type: clickActionSchema.nullable(),
        // undefined: 3_477 (40.26%), defined 5_159 (59.74%)
        // true 4_003 (77.59%), false 1_156 (22.41%)
        activation_mode_foreground: z.boolean().optional(),
        // null: 14 (0.16%)
        button_string: z.string().nullable(),
        // undefined: 3_477 (40.26%), defined 5_159 (59.74%)
        default_push_button: z.boolean().optional(),
        human_readable: z.string(),
        id: common.objectId,
        // true 871 (10.09%), false 7_765 (89.91%)
        marked_as_deleted: z.boolean(),
        // undefined: 3_477 (40.26%), defined 5_159 (59.74%)
        text: z.string().nullable().optional(),
        // null: 2_657 (30.77%)
        uri: z.string().nullable(),
        // true 7_933 (91.86%), false 703 (8.14%)
        use_webview: z.boolean(),
      })
    )
    .optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 771_245 (98.82%)
  ios_push_category: z.string().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 37 (0.00%)
  ios_push_message: z.string().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 774_950 (99.30%)
  // integer: 2_809 (51.18%)
  // avg: 0.85, min: 0, max: 1
  ios_relevance_score: z.number().min(0).max(1).nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 732_197 (93.82%)
  ios_sound: z.string().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 764_574 (97.97%)
  // avg: 1741208425.11, min: 1425599100, max: 1763423700
  ios_ttl: z.int().nonnegative().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 233_674 (29.94%)
  ios_uri: z.string().nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 112 (0.01%)
  // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
  ios_uri_type: clickActionSchema.nullable().optional(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // null: 2_085 (0.27%)
  // true 741_309 (95.24%), false 37_045 (4.76%)
  ios_use_webview: z.boolean().nullable().optional(),
  // avg: 306459801.65, min: 0, max: 1749555601
  last_sent_ios_push: z.int().min(0).nullable().optional(),
  // null: 8 (0.00%)
  link_template_ids: z.array(z.string()).nullable(),
  // undefined: 32_803 (4.03%), defined 780_439 (95.97%)
  // true 2_027 (0.26%), false 778_412 (99.74%)
  only_send_to_ios_10_plus: z.boolean().nullable().optional(),
});
